package fyi.moko.hotpl.data.service

/**
 * Holder for the Google Places API key, registered by each platform module. The key
 * itself lives in `local.properties` / platform config — never in committed source
 * (CLAUDE.md Secrets rule). When this config is absent or the key is blank, the
 * shared module falls back to [fyi.moko.hotpl.domain.service.StubPlaceSearchProvider]
 * and the Directory tab runs local-cache-only.
 */
data class PlacesSearchConfig(val apiKey: String?)
